<template>
  <v-card
    :loading="loading"
    >
    <v-card-text v-if="title" class="title">
      <div class="d-block d-sm-flex justify-space-between align-center">
        <div>
          {{ title }}
        </div>
        <div>
          <slot name="widget-header-action" />
        </div>
      </div>
    </v-card-text>
    <v-divider v-if="title" />

    <v-card-text>
      <slot name="widget-content" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AppWidget',
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
};
</script>
